import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getImageUrl, handleImageError } from '../utils/imageUtils';
import './SearchResultCard.css';

const SearchResultCard = ({ result }) => {
    const navigate = useNavigate();
    const [imageError, setImageError] = useState(false);

  const handleCardClick = () => {
    switch(result.type) {
      case 'property':
        navigate(`/propertyDetails/${result.id}`);
        break;
      case 'hotel':
        navigate(`/hotel/${result.id}`);
        break;
      case 'offer':
        navigate(`/singleprovider/${result.id}`);
        break;
      case 'userservice':
      case 'servicetype':
        navigate(`/serviceProvider`);
        break;
      default:
        break;
    }
  };

  const getTypeIcon = () => {
    switch(result.type) {
      case 'property': return 'fa-building';
      case 'hotel': return 'fa-hotel';
      case 'userservice':
      case 'servicetype':
      case 'offer': return 'fa-concierge-bell';
      default: return 'fa-search';
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'XAF'
    }).format(price).replace('XAF', 'XAF');
  };

  const imageUrl = getImageUrl(result.image, result.type);
  return (
    <div className="search-result-card" onClick={handleCardClick}>
      <div className="result-image">
          {imageUrl && !imageError ? (
            <img 
              src={imageUrl} 
              alt={result.title}
              onError={(e) => handleImageError(e, setImageError)}
              className="result-img"
            />
          ) : (
            <div className="image-placeholder">
              <i className={`fa ${getTypeIcon()}`}></i>
            </div>
          )}
        <div className="result-type-badge">
          <i className={`fa ${getTypeIcon()}`}></i>
          {result.type}
        </div>
      </div>

      <div className="result-content">
        <h3 className="result-title">{result.title}</h3>
        
        {result.description && (
          <p className="result-description">
            {result.description.length > 100 
              ? `${result.description.substring(0, 100)}...` 
              : result.description}
          </p>
        )}

        {result.location && (
          <div className="result-location">
            <i className="fa fa-map-marker-alt"></i>
            {result.location}
          </div>
        )}

        {result.price > 0 && (
          <div className="result-price">
            {formatPrice(result.price)}
            {result.type === 'hotel' && <span>/night</span>}
            {result.type === 'servicetype' && <span>/day</span>}
          </div>
        )}

        {result.rating > 0 && (
          <div className="result-rating">
            <i className="fa fa-star"></i>
            {result.rating.toFixed(1)}
          </div>
        )}

        {result.category && (
          <div className="result-category">
            {result.category} {result.subcategory && `• ${result.subcategory}`}
          </div>
        )}

        <div className="result-footer">
          <span className="result-date">
            Added {new Date(result.createdAt).toLocaleDateString()}
          </span>
          <button className="view-details-btn">
            View Details <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchResultCard;